const PRODUCT_PERFORMANCE_STATUS_ALIASES = new Map([
  ["completed", "completed"],
  ["processing", "processing"],
  ["cancelled", "cancelled"],
  ["canceled", "cancelled"],
  ["failed", "failed"],
  ["pending", "pending"],
  ["pending-payment", "pending"],
  ["quote-requested", "quote_requested"],
  ["refunded", "refunded"],
  ["partially-refunded", "partially_refunded"],
  ["on-hold", "on_hold"],
]);

const ELIGIBLE_PRODUCT_PERFORMANCE_STATUSES = new Set([
  "completed",
  "processing",
]);

export const getProductPerformanceOrderStatus = (order = {}) => (
  order?.status ?? order?.order_status ?? order?.OrderStatus ?? ""
);

export const normalizeProductPerformanceStatus = (value) => {
  const normalized = String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[\s_]+/g, "-")
    .replace(/^wc-/, "");

  return PRODUCT_PERFORMANCE_STATUS_ALIASES.get(normalized) || "unknown";
};

export const isProductPerformanceSaleEligible = (orderOrStatus) => {
  const status = orderOrStatus && typeof orderOrStatus === "object"
    ? getProductPerformanceOrderStatus(orderOrStatus)
    : orderOrStatus;

  return ELIGIBLE_PRODUCT_PERFORMANCE_STATUSES.has(
    normalizeProductPerformanceStatus(status)
  );
};
